/* newsletter-source.js
 *
 * Appends a chan-<channel> tag to every newsletter form on the page so each
 * subscriber is attributable to the channel that produced them.
 *
 * Reads utm_source first and falls back to document.referrer. The UTM parameter
 * is the reliable one: in-app browsers (Instagram, TikTok, Facebook) frequently
 * strip the referrer, so links MUST carry ?utm_source=... to be attributable.
 *
 * The base tag list is read from data-base-tags so repeated runs are harmless.
 * Wrapped in try/catch throughout: this theme renders the footer on every page,
 * and an uncaught error here would take the footer down sitewide.
 */
(function () {
  'use strict';

  function sanitize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9._-]/g, '')
      .substring(0, 28);
  }

  function fromUtm() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('utm_source') || '';
    } catch (e) {
      return '';
    }
  }

  function fromReferrer() {
    try {
      var ref = document.referrer || '';
      if (!ref) { return ''; }

      var host = new URL(ref).hostname.replace(/^www\./, '').toLowerCase();
      var self = window.location.hostname.replace(/^www\./, '').toLowerCase();
      if (!host || host === self) { return ''; }

      var known = {
        'instagram': ['instagram'],
        'pinterest': ['pinterest', 'pin.it'],
        'reddit': ['reddit', 'redd.it'],
        'facebook': ['facebook', 'fb.com', 'fb.me'],
        'twitter': ['t.co', 'twitter', 'x.com'],
        'tiktok': ['tiktok'],
        'youtube': ['youtube', 'youtu.be'],
        'tumblr': ['tumblr'],
        'quora': ['quora'],
        'etsy': ['etsy'],
        'linkedin': ['linkedin'],
        'google': ['google'],
        'bing': ['bing'],
        'duckduckgo': ['duckduckgo'],
        'chatgpt': ['chatgpt', 'openai'],
        'perplexity': ['perplexity'],
        'whop': ['whop']
      };

      for (var name in known) {
        if (!Object.prototype.hasOwnProperty.call(known, name)) { continue; }
        var needles = known[name];
        for (var i = 0; i < needles.length; i++) {
          if (host.indexOf(needles[i]) !== -1) { return name; }
        }
      }
      return host;
    } catch (e) {
      return '';
    }
  }

  function apply() {
    try {
      var channel = sanitize(fromUtm()) || sanitize(fromReferrer()) || 'direct';
      var inputs = document.querySelectorAll('input[name="contact[tags]"]');

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var base = input.getAttribute('data-base-tags');
        if (!base) {
          base = input.value || 'newsletter';
          input.setAttribute('data-base-tags', base);
        }
        if (base.indexOf('chan-') !== -1) { continue; }
        input.value = base + ',chan-' + channel;
      }
    } catch (e) {
      /* never let attribution break the page */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();